import React from "react";
import { Field } from "redux-form";
import { LabeledAutocomplete } from "./";

import { isRequired } from "js/helpers/validations";

const LabeledAutocompleteInner = ({
  input,
  meta: { touched, error },
  suggestions,
  label,
  placeholder,
  noOptionsMessage,
  disabled,
  isDisabled,
  ...custom
}) => {
  // Try to parse the value if it's a string (though it should be an object or undefined)
  let val = input.value;
  if (typeof val === "string" && val !== "") {
    try {
      val = JSON.parse(val);
    } catch (e) {
      // If it's not JSON, maybe it's just a simple value, but react-select expects { value, label }
      val = suggestions.find(s => s.value === val) || {
        value: val,
        label: val
      };
    }
  }

  // Ensure value is in the format { value, label } for react-select
  // If input.value is just a primitive, find it in suggestions
  if (val && typeof val !== "object") {
    val = suggestions.find(s => s.value === val) || { value: val, label: val };
  }

  return (
    <LabeledAutocomplete
      {...custom}
      label={label}
      placeholder={placeholder}
      suggestions={suggestions}
      isDisabled={isDisabled || disabled || false}
      isClearable={true}
      noOptionsMessage={noOptionsMessage}
      onChange={option => input.onChange(option ? option.value : "")}
      value={val}
      error={touched ? error : null}
    />
  );
};

const LabeledAutocompleteReduxForm = ({
  name,
  validate = [],
  required,
  ...props
}) => (
  <Field
    name={name}
    component={LabeledAutocompleteInner}
    validate={(() => {
      let validations = validate;
      if (required) {
        validations.push(isRequired);
      }
      return validations;
    })()}
    {...props}
  />
);

export default LabeledAutocompleteReduxForm;
